// extracted by mini-css-extract-plugin
export default {"wrapper":"Videos_wrapper__+tw9X","iframe":"Videos_iframe__ttgKh","title":"Videos_title__A-DPR"};